/**
 * Hook returning the current public config value.
 */

import { useContext } from 'react';
import { PublicConfigContext, type PublicConfig } from './publicConfigContextInstance';

export const usePublicConfig = (): PublicConfig => {
  const context = useContext(PublicConfigContext);
  if (!context) {
    throw new Error('usePublicConfig must be used within a PublicConfigProvider');
  }
  return context;
};
